import './styles/layout.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import {
  AuthPage,
  ResetPasswordPage,
  EmailConfirmationPage,
  Create,
  ShoppingCart,
  CheckoutPage,
  CheckoutSuccessPage,
  Home,
  OrdersPage,
  ProfilePage,
  FAQPage,
} from './pages';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { useNavbarHeight } from './hooks/useNavbarHeight';
import ErrorBoundary from './components/common/ErrorBoundary';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/common/ScrollToTop';
import Notification from './components/common/Notification';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import Footer from './components/layout/Footer';

function App() {
  useNavbarHeight();

  return (
    <HelmetProvider>
      <AuthProvider>
        <NotificationProvider>
          <ErrorBoundary>
            <Router>
              <ScrollToTop />
              <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/confirm-email" element={<EmailConfirmationPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route
                path="/home"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/create"
                element={
                  <ProtectedRoute>
                    <Create />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cart"
                element={
                  <ProtectedRoute>
                    <ShoppingCart />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/checkout"
                element={
                  <ProtectedRoute requireEmailConfirmed>
                    <CheckoutPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
              <Route
                path="/orders"
                element={
                  <ProtectedRoute requireEmailConfirmed>
                    <OrdersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <ProfilePage />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
              </Routes>
              <Footer />
              <Notification />
            </Router>
          </ErrorBoundary>
        </NotificationProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
